import React from 'react'
import { Outlet } from 'react-router-dom'

const VendorDeptStatMngPage = () => {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default VendorDeptStatMngPage